import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { SchoolUpdateTableValuesArray } from '@/types/view'
import { postData } from '../utils'
import { reloadGroupsWithSchoolsAndTanks } from '../utils/loadStorage'

// Helper to convert YYYYMMDD number to YYYY-MM-DD string
const formatDate = (dateNum: number): string => {
  const dateStr = String(dateNum)
  const year = dateStr.substring(0, 4)
  const month = dateStr.substring(4, 6)
  const day = dateStr.substring(6, 8)
  return `${year}-${month}-${day}`
}

// Type for the data with tankId (but without tankName and resultingCount)
type UpdateFormData = Omit<SchoolUpdateTableValuesArray[number], 'tankName' | 'resultingCount'>[]

const patchUpdateAPI = async (
  updateDate: number,
  updateForm: UpdateFormData,
  schoolIds: string[],
) => {
  // Transform to new v2 API format
  const list = updateForm.map((item) => ({
    tank_id: item.tankId,
    date: formatDate(updateDate),
    nh3: item.nh3 || 0,
    no2: item.no2 || 0,
    sample_weight: item.sampleWeight || 0,
    stock_count: 0,
    mortality_count: item.mortality || 0,
    harvest_count: item.harvest || 0,
    manual_amount: item.feedingAmount || 0,
    manual_count: item.feedTimes || 0,
  }))

  const response = await postData<string[]>('/tank/daily-records', { list })

  reloadGroupsWithSchoolsAndTanks()

  return response
}

export const usePatchUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      updateDate,
      updateForm,
      schoolIds,
    }: {
      updateDate: number
      updateForm: UpdateFormData
      schoolIds: string[]
    }) => patchUpdateAPI(updateDate, updateForm, schoolIds),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tankInfo'] })
    },

    onError: (error) => {
      console.log('Update API Error:', error)
    },
  })
}
